import { Component } from '@angular/core';

@Component({
  selector: 'kve-input-dialog-wrapper',
  templateUrl: './input-dialog-wrapper.component.html',
  styleUrls: ['./input-dialog-wrapper.component.scss']
})
export class InputDialogWrapperComponent {

}
